var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"tabbed_content fluid_tabs cf"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.instantWin)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }